module.exports = __webpack_public_path__ + "static/img/legal.c3ec40f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguros-arl/Especialidades/legal.png
// module id = 65JC
// module chunks = 0